<template>
  <q-dialog v-model="modal.show"
            @keydown.escape="close()"
            persistent
            transition-show="scale"
            transition-hide="scale">
    <q-card style="max-width: 250px; width: 100%; padding: 15px;">
      <h5>Edit depreciation override</h5>
      <p class="self-center" v-if="isFetching" style="text-align: center">
        <q-spinner-facebook size="45px" color="primary" />
      </p>
      <div v-else>
        <div class="row">
          <div class="col">
            <q-input label="Value"
                     v-model="value"
                      :error="errors.value !== null"
                      :error-message="errors.value"
                     @keydown.enter.prevent="save"
                     autofocus
                     type="number"></q-input>
          </div>
        </div>
        <div class="flex justify-between" style="margin-top: 15px;">
          <q-btn label="Cancel"
                 color="red"
                 :disable="isLoading"
                 @click="close()"></q-btn>
          <q-btn label="Save"
                 color="green"
                 :loading="isLoading"
                 :disable="isLoading"
                 @click="save()"></q-btn>
        </div>
      </div>
    </q-card>
  </q-dialog>
</template>

<script>
import axios from '../axios/index'
export default {
  props: {
    updateTable: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      isFetching: false,
      isLoading: false,
      item: null,
      value: null,
      errors: {
        value: null
      }
    }
  },
  computed: {
    modal: {
      get() {
        return this.$store.state.depreciationOverrides.setEditModal
      },
      set(value) {
        this.$store.commit('depreciationOverrides/SET_EDIT_MODAL', value)
      }
    }
  },
  methods: {
    async getItem(id) {
      try {
        this.isFetching = true
        const {data} = await axios.get('/depreciation-override/' + id)
        this.item = data.data
        this.value = this.item.value
      } catch (err) {
        console.log(err)
        this.close()
      } finally {
        this.isFetching = false
      }
    },
    reset() {
      this.errors = {
        value: null
      }
      this.loading = false
      this.value = null
    },
    close() {
      this.reset()
      this.$store.commit('depreciationOverrides/SET_EDIT_MODAL', {
        show: false,
        id: null
      })
    },
    async save() {
      try {
        this.isLoading = true
        await axios.put('/depreciation-overrides', {
          location_id: this.item?.location.id,
          vehicle_model_id: this.item?.vehicle_model.id,
          value: this.value
        })
        this.reset()
        this.updateTable()
        this.close()
      } catch (err) {
        if (err.response.status === 422) {
          this.$q.notify({
            message: err.response.data.message,
            color: 'red',
            timeout: 250,
            position: 'top-right',
            progress: true
          })
          const errors = err.response.data.errors
          Object.keys(errors).map(key => {
            this.errors[key] = errors[key][0]
          })
        } else {
          this.$q.notify({
            message: 'Something went wrong',
            color: 'red',
            timeout: 250,
            position: 'top-right',
            progress: true
          })
        }
      } finally {
        this.isLoading = false
      }
    }
  },
  watch: {
    modal: {
      handler(value) {
        if (value.show && value.id) {
          this.getItem(value.id)
        }
      },
      deep: true
    }
  }
}
</script>
<style scoped>
h5 {
  margin: 5px;
  font-size: 18px;
}
.col {
  padding: 0 5px;
}
.file-input label {
  display: flex;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.24);
  height: 100%;
  width: 100%;
  align-items: center;
  justify-content: center;
  color: #bdbdbd;
  font-weight: bold;
  transition: transform 0.2s ease-out;
  cursor: pointer;
}
input:hover + label {
  cursor: pointer;
  background: rgb(189, 189, 189, 0.2);
}
</style>
